import { EventDispatcher } from "../events/EventDispatcher";
import { LayaGL } from "../layagl/LayaGL";
import { Vector2 } from "../maths/Vector2";
import { RenderTexture2D } from "../resource/RenderTexture2D";
import { Effect2DShaderInit } from "./effect2d/shader/Effect2DShaderInit";
import { CommandBuffer2D } from "./Scene2DSpecial/RenderCMD2D/CommandBuffer2D";
import { RepaintFlag, SpriteConst, SubPassFlag } from "./SpriteConst";
export class PostProcess2D extends EventDispatcher {
    static init() {
        Effect2DShaderInit.colorEffect2DShaderInit();
        Effect2DShaderInit.blurEffect2DShaderInit();
        Effect2DShaderInit.glow2DShaderInit();
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled != value) {
            this._enabled = value;
            this._context.command.clear(true);
            this._onChangeRender();
        }
    }
    constructor() {
        super();
        this._effects = [];
        this._enabled = true;
        this._hasCleanRT = false;
        this._context = new PostProcessRenderContext2D();
        this._context.compositeShaderData = LayaGL.renderDeviceFactory.createShaderData(null);
        this._context.command = new CommandBuffer2D();
    }
    get owner() {
        return this._owner;
    }
    set owner(value) {
        if (this._owner) {
            this._owner._renderType &= ~SpriteConst.POSTPROCESS;
        }
        this._owner = value;
        if (this._owner) {
            if (this._effects.length > 0 && this._enabled)
                this._owner._renderType |= SpriteConst.POSTPROCESS;
        }
    }
    _checkEnabled() {
        if (this._effects.length === 0 || !this._enabled)
            return false;
        for (let i = 0; i < this._effects.length; i++) {
            if (this._effects[i].active)
                return true;
        }
        return false;
    }
    _onChangeRender() {
        if (this._owner) {
            if (this._checkEnabled()) {
                this._owner._renderType |= SpriteConst.POSTPROCESS;
            }
            else {
                this._owner._renderType &= ~SpriteConst.POSTPROCESS;
            }
            this._owner.setSubpassFlag(SubPassFlag.PostProcess);
            this._owner.repaint(RepaintFlag.Graphics);
        }
    }
    getEffect(classReg) {
        return this._effects.find(effect => effect instanceof classReg) || null;
    }
    setResource(value) {
        this._context.source = value;
    }
    getDestRT() {
        return this._context.destination;
    }
    get effects() {
        return this._effects;
    }
    set effects(value) {
        this._effects.filter(e => !value.includes(e)).forEach(effect => effect.destroy());
        this._effects.length = 0;
        for (let i = 0, n = value.length; i < n; i++) {
            if (value[i])
                this.addEffect(value[i]);
        }
        this._onChangeRender();
    }
    addEffect(effect) {
        if (effect.destroyed) {
            console.error("the target effect is destroyed", effect);
            return null;
        }
        if (effect.singleton && this.getEffect(effect.constructor)) {
            console.error("the target effect is a singleton", effect);
            return null;
        }
        this._effects.push(effect);
        effect.effectInit(this);
        this._onChangeRender();
        return effect;
    }
    removeEffect(effect) {
        let index = this._effects.indexOf(effect);
        if (index !== -1) {
            this._effects.splice(index, 1);
            effect.destroy();
            this._onChangeRender();
        }
    }
    _render() {
        this._context.command.clear(true);
        this._context.indirectTarget = this._context.source;
        this._context.destination = this._context.source;
        for (var i = 0, n = this._effects.length; i < n; i++) {
            let effect = this._effects[i];
            if (effect.active && !effect.destroyed) {
                effect.render(this._context);
                this._context.indirectTarget = this._context.destination;
            }
        }
        this._hasCleanRT = false;
    }
    clear() {
        for (let i = 0; i < this._effects.length; i++) {
            this._effects[i].destroy();
        }
        this._effects.length = 0;
        this._onChangeRender();
    }
    clearCMD() {
        this._context.command.clear();
    }
    recoverAllRTS() {
        this._context.destination = null;
        for (let effect of this._effects) {
            effect.clearRT(this._context);
        }
        this._hasCleanRT = true;
    }
    apply() {
        if (this._hasCleanRT) {
            this.clearCMD();
            this._render();
            this._hasCleanRT = false;
        }
        this._context._apply();
        for (let i = 0, n = this._effects.length; i < n; i++) {
            let effect = this._effects[i];
            effect.clearRT(this._context);
        }
        this._hasCleanRT = true;
    }
    destroy() {
        this.owner = null;
        this._context.compositeShaderData.destroy();
        this._context.compositeShaderData = null;
        this._effects.forEach(effect => effect.destroy());
        this._effects.length = 0;
    }
}
export class PostProcessRenderContext2D {
    constructor() {
        this.deferredReleaseTextures = [];
        this.oriOffset = new Vector2();
    }
    getRenderTexture(width, height, colorFormat, depthFormat) {
        let rt = RenderTexture2D.createFromPool(width, height, colorFormat, depthFormat);
        return rt;
    }
    _apply() {
        this.command.apply(true);
    }
}
